
export const InterceptorSkipHeader = 'X-Skip-Interceptor';

export const appConfig = {
    hash_session: 'easyfines_hash_sess_29823',
    lang_session: 'easyfines_lang_sess_29823',
    data_session: 'easyfines_data_sess_29823'
};
